import EntityTable from "@mirage/components/entityTable/EntityTable";
import LinkCell from "@mirage/components/entityTable/components/LinkCell";
import { Box } from "@mui/system";
import { GridColDef } from "@mui/x-data-grid-premium";
import EnforcementAppealsService from "@publicPortal/services/EnforcementAppealsService";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import React, { memo, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { SearchResultTableProps } from "./PlanningApplicationsTable";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";

const service = new EnforcementAppealsService();
const pp = new PublicPortalRoutingService();

const EnforcementAppealsTable: React.FC<SearchResultTableProps> = memo(({ filter, title, customPageRequest }) => {
    const navigate = useNavigate();
    const getRecordDetailRoute = useCallback((id: number) => {
        return pp.EnforcementAppealsRecordRoute(id);
    }, []);
    const onPageRequest = useCallback(
        async (pr: IEntityPageRequest) => {
            if (customPageRequest) {
                return await customPageRequest(pr);
            }
            const response = await service.pageRequest(pr);
            return response;
        },
        [customPageRequest]
    );
    const columns = useMemo((): GridColDef[] => {
        return [
            { field: "name", headerName: "Appeal Ref No.", renderCell: (params) => <LinkCell value={params.value} route={getRecordDetailRoute(Number(params.id))} /> },
            { field: "appeal_type", headerName: "Appeal Type" },
            { field: "appeal_level", headerName: "Appeal Level" },
            { field: "date_started", headerName: "Date Started", type: "date" },
        ];
    }, [getRecordDetailRoute]);

    return (
        <Box sx={{ marginTop: "32px", height: "auto" }}>
            <EntityTable
                title={title}
                key="enforcement-appeals-entityTable"
                stateKey="enforcementAppeals"
                onPageRequest={customPageRequest ? customPageRequest : onPageRequest}
                columns={columns}
                filter={filter}
                onRecordSelected={(record) => navigate(getRecordDetailRoute(record.id))}
            />
        </Box>
    );
});

export default EnforcementAppealsTable;
